/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { FormItemWrapper, Select } from './common';
import FormError from './common/FormError';

const SelectField = (props) => {
  const { field, form, label, optionArray, onChange, required } = props;
  const { name } = field;
  const { touched, errors } = form;
  const error = errors[name];
  const touch = touched[name];
  if (onChange) {
    return (
      <FormItemWrapper label={label} required={required} name={name}>
        <Select
          {...field}
          onChange={onChange}
          id={name}
          hasError={touch && error}
        >
          {renderSelectOptions(optionArray)}
        </Select>

        <FormError touch={touch} error={error} />
      </FormItemWrapper>
    );
  }
  return (
    <FormItemWrapper label={label} required={required} name={name}>
      <Select {...field} id={name} hasError={touch && error}>
        {renderSelectOptions(optionArray)}
      </Select>
      <FormError touch={touch} error={error} />
    </FormItemWrapper>
  );
};

const PureSelect = (props) => {
  const { label, name, value, optionArray, onChange } = props;
  return (
    <FormItemWrapper label={label} name={name}>
      <Select name={name} id={name} value={value} onChange={onChange}>
        {renderSelectOptions(optionArray)}
      </Select>
    </FormItemWrapper>
  );
};

export { PureSelect };

export default SelectField;

const renderSelectOptions = (optionArray) =>
  optionArray.map((option) => (
    <option value={option.value} key={option.value}>
      {option.option}
    </option>
  ));
